import { Component } from '@angular/core';
import { BnNgIdleService } from 'bn-ng-idle';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UserService } from './services/user.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'angular-routing-example';

  constructor(public router: Router, private bnIdle: BnNgIdleService,private userService: UserService) {
    //8hrs = 28800 seconds //7200
    this.bnIdle.startWatching(7200).subscribe((res) => {
        if (res) {
          try { 
            console.log('idle time out');

            this.userService.logout();
            sessionStorage.removeItem('iammwtoken');
           // window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Fsmartloginuat.dewa.gov.ae';
  
            setTimeout(function(){ 
              console.log('idle time out step 2');
              window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Fsmartloginuat.dewa.gov.ae';

              setTimeout(function(){ 
                console.log('idle time out step 3');
                window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Fsmartloginuat.dewa.gov.ae';
               }, 500);

             }, 500);

          }
          catch (err) {
            console.log(err);
            setTimeout(function(){ 
              console.log('idle time out step 4');
              window.location.href = environment.issuer_uri + '/idp/startSLO.ping?TargetResource=https%3A%2F%2Fsmartloginuat.dewa.gov.ae';
             }, 500);
          }
        }


    })

}
}
